import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Link from 'react-router/lib/Link';
import RosettaFormattedMessage from '../common/rosetta_formatted_message';
import { CONDENSED_HEADER } from '../../constants';
import classNames from 'classnames';
import { nodeAttrs } from '../../utils/dom';
import { sendAnalyticsEvent, sendDataLayerEvent } from '../../utils/analytics';
import SocialIcons from '../common/social_icons';
import { StaticAssets } from '../common/static_assets.js';
import {pick, throttle} from 'lodash';

const ARTICLE_TOP_CLASS_NAME = '.article-top, .dek';
const PX_THRESHOLD_FROM_TOP_SHARE_ICONS = 0;
const FOOTER_CLASS_NAME = 'footer';
const PX_THRESHOLD_FROM_FOOTER = 190;

const handleClick = () => {
  sendAnalyticsEvent(
    'Logo',
    'Click',
    'Top Nav'
  );

  sendDataLayerEvent('Click', {
    linkTitle: 'Logo',
    linkType: 'logo',
    pageModule: 'Header'
  });
};

export default class CondensedHeader extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { isHidden: true };
    this.handleScroll = throttle(
      this.handleScroll.bind(this),
      this.props.throttleWait
    );
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  }

  shouldComponentUpdate(_, nextState) {
    return nextState.isHidden !== this.state.isHidden;
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    if (this.state.isHidden !== this.shouldBeHidden()) {
      this.setState({ isHidden: !this.state.isHidden });
    }
  }

  shouldBeHidden() {
    if (this.props.onSlideshowArticle) {
      const shareIcons = document.getElementsByClassName(FOOTER_CLASS_NAME)[0];
      return !shareIcons || nodeAttrs(shareIcons).top > PX_THRESHOLD_FROM_FOOTER;
    }
    const shareIcons = document.querySelectorAll(ARTICLE_TOP_CLASS_NAME)[0];
    return !shareIcons || nodeAttrs(shareIcons).bottom > PX_THRESHOLD_FROM_TOP_SHARE_ICONS;
  }

  render() {
    const headerClass = classNames(CONDENSED_HEADER, {
      hidden: this.state.isHidden
    });

    const socialIconProps = pick(this.props, [
      'asset_main',
      'opener_images',
      'enableAdTextForShares',
      'sanitizedTitle',
      'url_full',
      'meta_description',
      'meta_title',
      'social_title',
      'excerpt_truncated_325',
      'parentClass'
    ]);

    const title = this.props.truncated_short_title_80 || this.props.title;

    return (
      <header hidden={this.state.isHidden} className={headerClass}>
        <Link
          to={'/' + this.context.edition_data.basename}
          onClick={handleClick}
        >
          <div className="r29-logo">
            <img src={StaticAssets.r29LogoRegMarkB} alt="Refinery29" />
          </div>
        </Link>
        <div className="condensed-title">
          <RosettaFormattedMessage parentFilename={__filename}
            id="subtitle"
            description="Header subtitle"
            defaultMessage="Now Reading"
          />
          <h4 dangerouslySetInnerHTML={{ __html: title }} />
        </div>
        <SocialIcons
          {...socialIconProps}
          icons={['facebook', 'pinterest', 'email']}
        />
      </header>
    );
  }
}

CondensedHeader.propTypes = {
  asset_main: PropTypes.object.isRequired,
  opener_images: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    asset: PropTypes.shape({
      credit: PropTypes.string,
      src: PropTypes.shape({
        full: PropTypes.string
      })
    })
  })).isRequired,
  enableAdTextForShares: PropTypes.bool.isRequired,
  onSlideshowArticle: PropTypes.bool.isRequired,
  sanitizedTitle: PropTypes.string.isRequired,
  truncated_short_title_80: PropTypes.string.isRequired,
  throttleWait: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  url_full: PropTypes.string.isRequired
};

CondensedHeader.defaultProps = {
  asset_main: {},
  opener_images: [],
  enableAdTextForShares: false,
  onSlideshowArticle: false,
  sanitizedTitle: '',
  truncated_short_title_80: '',
  throttleWait: 500,
  title: '',
  url_full: ''
};

CondensedHeader.contextTypes = {
  edition_data: PropTypes.object
};
